const _excluded = ["className", "style", "variant", "selected", "today", "disabled", "hasEvent", "tooltipContent"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { BasicButton } from '@adsk/alloy-react-button';
import { variantSwitch } from '@adsk/alloy-react-helpers';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import Tooltip from '@adsk/alloy-react-tooltip';
import { DATE_PICKER_CELL_VARIANTS } from '../consts';
const Cell = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      className,
      style,
      variant = DATE_PICKER_CELL_VARIANTS.DEFAULT,
      selected,
      today,
      disabled,
      hasEvent,
      tooltipContent
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const children = /*#__PURE__*/React.createElement(BasicButton, _extends({}, props, {
    ref: ref,
    className: className,
    tabIndex: variant === DATE_PICKER_CELL_VARIANTS.SPACER ? -1 : undefined,
    style: [{
      width: 40,
      height: 40,
      cursor: disabled ? 'default' : 'pointer',
      justifyContent: 'center',
      alignItems: 'center',
      display: 'inline-flex',
      position: 'relative'
    }, theme.typography.bodyMediumBold, variantSwitch({
      statement: variant,
      variants: {
        [DATE_PICKER_CELL_VARIANTS.DEFAULT]: _objectSpread(_objectSpread({
          borderRadius: theme.borderRadius.medium,
          color: today ? theme.tokens.colors.text.selected.value : theme.tokens.colors.text.primary.value,
          '&:hover': {
            backgroundColor: theme.tokens.colors.background.neutral.hover.value
          },
          '&:focus': {
            backgroundColor: theme.tokens.colors.background.primary.value,
            boxShadow: "inset 0px 0px 0px 1px ".concat(theme.tokens.colors.border.focused.value, ", inset ").concat(theme.halos.focus)
          },
          '&:active': {
            backgroundColor: theme.tokens.colors.background.neutral.pressed.value,
            boxShadow: today ? "inset 0px 0px 0px 1px ".concat(theme.tokens.colors.border.selected.value) : 'none'
          }
        }, disabled && {
          color: theme.tokens.colors.text.inactive.value,
          backgroundColor: theme.tokens.colors.background.primary.value,
          cursor: 'not-allowed',
          '&:hover': {
            boxShadow: 'none',
            backgroundColor: theme.tokens.colors.background.primary.value
          },
          '&:focus, &:active': {
            backgroundColor: theme.tokens.colors.background.primary.value,
            boxShadow: 'none'
          }
        }), selected && {
          color: theme.tokens.colors.text.inverse.value,
          backgroundColor: theme.tokens.colors.background.selected.value,
          '&:hover, &:focus, &:active': {
            boxShadow: 'none',
            backgroundColor: theme.tokens.colors.background.selected.value
          }
        }),
        [DATE_PICKER_CELL_VARIANTS.RANGE_MIDDLE]: {
          borderRadius: theme.borderRadius.none,
          backgroundColor: theme.tokens.colors.background.selected.subtler.value,
          '&:hover': {
            color: theme.tokens.colors.text.inverse.value,
            backgroundColor: theme.tokens.colors.background.hover.value
          }
        },
        [DATE_PICKER_CELL_VARIANTS.RANGE_START]: {
          color: theme.tokens.colors.text.inverse.value,
          borderRadius: "".concat(theme.borderRadius.medium, "px ").concat(theme.borderRadius.none, " ").concat(theme.borderRadius.none, " ").concat(theme.borderRadius.medium, "px"),
          backgroundColor: theme.tokens.colors.background.selected.value,
          '&:hover': {
            color: theme.tokens.colors.text.inverse.value,
            backgroundColor: theme.tokens.colors.background.hover.value
          }
        },
        [DATE_PICKER_CELL_VARIANTS.RANGE_END]: {
          color: theme.tokens.colors.text.inverse.value,
          borderRadius: "".concat(theme.borderRadius.none, " ").concat(theme.borderRadius.medium, "px  ").concat(theme.borderRadius.medium, "px ").concat(theme.borderRadius.none),
          backgroundColor: theme.tokens.colors.background.selected.value,
          '&:hover': {
            color: theme.tokens.colors.text.inverse.value,
            backgroundColor: theme.tokens.colors.background.hover.value
          }
        },
        [DATE_PICKER_CELL_VARIANTS.OUTSIDE_RANGE_MIDDLE]: {
          borderRadius: theme.borderRadius.none,
          backgroundColor: theme.tokens.colors.background.selected.subtler.value,
          '&:hover': {
            color: theme.tokens.colors.text.inverse.value,
            backgroundColor: theme.tokens.colors.background.hover.value
          }
        },
        [DATE_PICKER_CELL_VARIANTS.OUTSIDE_RANGE_START]: {
          color: theme.tokens.colors.text.inverse.value,
          borderRadius: "".concat(theme.borderRadius.medium, "px ").concat(theme.borderRadius.none, " ").concat(theme.borderRadius.none, " ").concat(theme.borderRadius.medium, "px"),
          backgroundColor: theme.tokens.colors.background.selected.value,
          '&:hover': {
            color: theme.tokens.colors.text.inverse.value,
            backgroundColor: theme.tokens.colors.background.hover.value
          }
        },
        [DATE_PICKER_CELL_VARIANTS.OUTSIDE_RANGE_END]: {
          color: theme.tokens.colors.text.inverse.value,
          borderRadius: "".concat(theme.borderRadius.none, " ").concat(theme.borderRadius.medium, "px  ").concat(theme.borderRadius.medium, "px ").concat(theme.borderRadius.none),
          backgroundColor: theme.tokens.colors.background.selected.value,
          '&:hover': {
            color: theme.tokens.colors.text.inverse.value,
            backgroundColor: theme.tokens.colors.background.hover.value
          }
        },
        [DATE_PICKER_CELL_VARIANTS.OUTSIDE]: {
          borderRadius: theme.borderRadius.medium,
          color: theme.tokens.colors.text.inactive.value,
          backgroundColor: theme.tokens.colors.background.primary.value,
          '&:hover, &:focus, &:active': {
            backgroundColor: theme.tokens.colors.background.secondary.value
          }
        },
        [DATE_PICKER_CELL_VARIANTS.SPACER]: _objectSpread({
          cursor: 'default',
          pointerEvents: 'none'
        }, theme.typography.bodyMedium)
      }
    }), style]
  }), props.children, hasEvent && /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      top: 30,
      borderRadius: theme.borderRadius.circle,
      backgroundColor: selected ? theme.tokens.colors.text.inverse.value : theme.tokens.colors.text.primary.value,
      minHeight: 6,
      minWidth: 6,
      height: 6,
      width: 6,
      maxHeight: 6,
      maxWidth: 6
    }
  }));
  if (tooltipContent) {
    return /*#__PURE__*/React.createElement(Tooltip, {
      variant: Tooltip.VARIANTS.DARK,
      placement: Tooltip.PLACEMENTS.TOP,
      content: tooltipContent,
      delayShow: 0,
      delayHide: 0,
      getTargetProps: () => ({
        style: {
          width: 40,
          height: 40
        }
      })
    }, children);
  }
  return children;
});
Cell.displayName = 'Cell';
Cell.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Day value */
  children: PropTypes.any,
  /**  The style variant */
  variant: PropTypes.oneOf(Object.values(DATE_PICKER_CELL_VARIANTS)),
  /** Whether this day is selected, does not apply when variant is a range variant */
  selected: PropTypes.bool,
  /** Whether this day is the today day, does not apply when variant is a range variant */
  today: PropTypes.bool,
  /** Whether this day is the restricted */
  disabled: PropTypes.bool,
  /** Tooltip content */
  tooltipContent: PropTypes.any
};
export default Object.assign(Cell, {
  VARIANTS: DATE_PICKER_CELL_VARIANTS
});
//# sourceMappingURL=Cell.js.map